module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chap-title1"
  }, [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fuse beads have long been a popular material used for creating eye-catching and stunning objects, while allowing your imagination to run wild. Beads are arranged on a plastic pegboard and then ironed to melt them together. The brightly coloured beads are inexpensive, accessible and versatile, making them a perfect crafting medium for adults as well as kids.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s so easy to create fun, colourful designs that, with very little equipment, can be turned into pictures, jewellery, 3d objects, gifts, home ware and much more. This book is packed with ideas for crafty creations, but don’t limit yourself to what you see here – adapt, personalize and change colours wherever you want to – it’s simple to add your own creativity with fuse beads. There’s something extremely satisfying about watching all the tiny beads fuse and solidify to make your design permanent!")]), _vm._v(" "), _c('div', {
    staticClass: "tip-box"
  }, [_c('h2', {
    staticClass: "tip-head"
  }, [_vm._v("Fuse Bead Brands")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("There are many different brands of fuse beads available, the main ones being Hama in Europe and Perler in the US. These are both good quality and have consistent melting rates, meaning it’s usually possible to mix these brands if desired without too much trouble. However, the outcome is likely to be less reliable if you use some of the cheaper beads, as their melting rates are often inconsistent and the sizes of beads tend to vary. Other popular brands include Nabbi and Pyssla (available from Ikea).")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("Any type of fuse beads can be used for the designs in this book, just be sure to check which sized beads are required for each project.")])]), _vm._v(" "), _c('div', {
    staticClass: "tip-box"
  }, [_c('h2', {
    staticClass: "tip-head"
  }, [_vm._v("Warning")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("If you are planning on letting the kids get creative with their designs, make sure they leave the ironing to an adult to avoid injury.")])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/Intro1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7537d72c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Introduction.vue
// module id = 66
// module chunks = 0